import { Card, Image, List, Space } from 'antd';
import { getLogoUrl } from 'shared/constants';
import fallbackLogo from 'assets/fallbackLogo.png';
import millify from 'millify';
import React from 'react';
import './Acquisitions.scss';

interface AcquisitionsProps {
  acquisitions: any[];
}

export const Acquisitions = ({ acquisitions }: AcquisitionsProps) => {
  return (
    <div className="acquisitions mt-5">
      <h3 className="text-xl font-semibold">Acquisitions({acquisitions?.length})</h3>
      <List
        grid={{
          gutter: 16
        }}
        dataSource={acquisitions}
        renderItem={(item: any) => (
          <List.Item className="grid">
            <Card className="w-48 min-w-max border-gray-500 bg-gray-100" bordered={true}>
              <Space>
                <Image
                  preview={false}
                  className="max-h-8"
                  src={item?.website ? getLogoUrl(item?.website) : fallbackLogo}
                  fallback={fallbackLogo}
                />
                <div>
                  <div className="truncate w-36" title={item.name}>
                    {item.name}
                  </div>
                  <div>
                    {item?.amount && item?.undisclosed == 'false'
                      ? `$${millify(Number(item?.amount), { precision: 2 })}`
                      : 'Undisclosed'}
                  </div>
                </div>
              </Space>
            </Card>
          </List.Item>
        )}
      />
    </div>
  );
};
